
import { Component, Vue, Prop } from 'vue-property-decorator';
import { ALL_STATES, IQueueJobState } from '../utils'

@Component()
export default class QueueStatusesArrow extends Vue {

  @Prop({default: ''})
  public tooltip!: string

  @Prop()
  public currentStatus!: string;

  @Prop()
  public currentId!: string;



  get getTooltip() {
    return this.tooltip || this.getCurrentStatusItem.label;
  }

  get getStatuses(): IQueueJobState[] {
    return ALL_STATES
  }

  get getCurrentStatusItem() {
    const currentElement = this.getStatuses
      .find((it: IQueueJobState) => it && it.nameTech === this.currentStatus)
    return currentElement
  }

}//
